import moment from 'moment';
import React, {useMemo} from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {NavigationProp, useNavigation} from '@react-navigation/native';
import {useSelector} from 'react-redux';
import {RootState} from '../../redux/store';
import {theme} from '../../theme/theme';
import ReportChartCard from './ReportChartCard';
import {permittedReportCharts} from './registry';

import T from '../../Components/T';
/** Dashboard section: first permitted report chart(s) for the month up to `date`. */
const DashboardReportCharts = ({date, max = 1}: {date: Date; max?: number}) => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const navigation = useNavigation<NavigationProp<any>>();
  const entries = useMemo(() => permittedReportCharts(gdata.menu), [gdata.menu]);
  if (!entries.length) {
    return null;
  }
  const tdt = moment(date).format('YYYY-MM-DD');
  const fdt = moment(date).startOf('month').format('YYYY-MM-DD');
  return (
    <View style={styles.wrap}>
      <View style={styles.header}>
        <Text style={styles.title}><T>Your Reports ·</T> {moment(date).format('MMM YYYY')}</Text>
        <TouchableOpacity onPress={() => navigation.navigate('ReportCharts')}>
          <Text style={styles.link}><T>View all</T></Text>
        </TouchableOpacity>
      </View>
      {entries.slice(0, max).map(e => (
        <ReportChartCard key={e.key} entry={e} cid={gdata.company} fdt={fdt} tdt={tdt} />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: {marginTop: 8},
  header: {flexDirection: 'row', justifyContent: 'space-between', marginBottom: 8},
  title: {fontSize: 15, fontWeight: '700', color: theme.colors.charcoal},
  link: {color: theme.colors.primary, fontWeight: '600'},
});

export default DashboardReportCharts;
